module.exports = __webpack_public_path__ + "static/media/others.a3aac614.svg";